module.exports = __webpack_public_path__ + "img/pie-chart-placeholder.dc46107c.svg";